import { Bot, ChevronDown, Circle, RadioTower, Search, Shield, UserRound } from "lucide-react";
import { useState } from "react";
import { DelegationTarget, SquadItem } from "../../lib/commandCore";
import { clsx } from "clsx";

const icons: Record<DelegationTarget, typeof Bot> = {
  taiga: UserRound,
  codex: Bot,
  claude: Shield,
  grok: Search,
  hermes: RadioTower,
};

const tones = {
  good: "border-emerald-200 bg-emerald-50 text-emerald-800 dark:border-emerald-400/25 dark:bg-emerald-400/10 dark:text-emerald-100",
  watch: "border-amber-200 bg-amber-50 text-amber-800 dark:border-amber-400/25 dark:bg-amber-400/10 dark:text-amber-100",
  danger: "border-rose-200 bg-rose-50 text-rose-800 dark:border-rose-400/25 dark:bg-rose-400/10 dark:text-rose-100",
  neutral: "border-border bg-bg text-muted dark:border-zinc-700 dark:bg-zinc-900 dark:text-zinc-300",
};

export function AiSquadQueue({ squad }: { squad: SquadItem[] }) {
  // デフォルト折りたたみ。待機キューは一等地を占有しないよう開いた時だけ表示。
  const [open, setOpen] = useState(false);

  return (
    <section className="command-card">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center justify-between gap-3 p-4 text-left"
      >
        <div className="flex items-center gap-3">
          <div className="flex h-9 w-9 items-center justify-center rounded-md bg-hover text-brand-600 dark:bg-zinc-900 dark:text-indigo-200">
            <RadioTower className="h-4 w-4" />
          </div>
          <div>
            <p className="command-dim text-sm font-semibold">AIチーム</p>
            <h2 className="text-xl font-bold">委任先キュー</h2>
          </div>
        </div>
        <ChevronDown className={`command-dim h-5 w-5 transition ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="space-y-2 border-t border-border p-4 dark:border-white/10">
          {squad.map((item) => {
            const Icon = icons[item.id];
            return (
              <div key={item.id} className={clsx("flex items-center gap-3 rounded-md border p-3", tones[item.tone])}>
                <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-black/5 dark:bg-black/20">
                  <Icon className="h-4 w-4" />
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2">
                    <p className="font-semibold">{item.label}</p>
                    {item.count > 0 && (
                      <span className="rounded-full bg-black/5 px-2 py-0.5 font-mono text-[11px] dark:bg-white/15">
                        {item.count}
                      </span>
                    )}
                  </div>
                  <p className="truncate text-xs opacity-90">{item.role}</p>
                </div>
                <div className="flex shrink-0 items-center gap-1 text-xs">
                  <Circle className={clsx("h-2 w-2 fill-current", item.count > 0 ? "opacity-100" : "opacity-50")} />
                  {item.status}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </section>
  );
}
